import { MapPin } from "lucide-react";

const TOWNS = [
  "Patchogue","Medford","Bay Shore","Islip","Brentwood","Sayville","Bohemia","Holbrook",
  "Ronkonkoma","Holtsville","Farmingville","Selden","Centereach","Coram","Port Jefferson",
  "Stony Brook","Setauket","Smithtown","Hauppauge","Commack","Kings Park","Northport",
  "Huntington","Deer Park","Wyandanch","West Islip","Babylon","Lindenhurst","Amityville","Copiague",
  "Massapequa","Seaford","Wantagh","Bellmore","Merrick","Freeport","Hempstead"
];

export default function ServiceArea() {
  return (
    <section
      id="service-area"
      className="relative overflow-hidden"
      data-testid="service-area-section"
      style={{ background: "linear-gradient(180deg, #78B7E6 0%, #A9D3F0 100%)" }}
    >
      {/* Faded Long Island map watermark */}
      <img
        src="https://customer-assets.emergentagent.com/job_heat-dispatch/artifacts/2miawa52_image.png"
        alt=""
        aria-hidden
        className="pointer-events-none select-none absolute inset-0 w-full h-full object-contain opacity-15"
        style={{ filter: "saturate(1.1)" }}
        data-testid="service-area-map-watermark"
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32">
        <div className="grid md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-5">
            <div className="relative inline-block mb-6">
              <div className="bg-brand-red text-white px-6 py-3 border-2 border-brand-navy shadow-[6px_6px_0_#0A1128] -rotate-1">
                <div className="font-heading text-2xl sm:text-3xl tracking-tight" style={{ textShadow: "2px 2px 0 #0A1128" }}>
                  SERVICE <span className="text-brand-gold">AREA</span>
                </div>
              </div>
            </div>
            <h2 className="font-heading text-4xl md:text-5xl leading-[1.05] mb-5 text-brand-navy" data-testid="service-area-heading">
              Suffolk County and beyond.
            </h2>
            <p className="text-brand-navy/80 leading-relaxed mb-8">
              From the south shore to the north fork, our trucks cover every ZIP in Suffolk and most of Nassau. Not sure we deliver to you? Call us — odds are we do.
            </p>
            <a href="tel:6313723526" className="inline-flex items-center gap-2 bg-brand-red text-white px-6 py-3.5 font-heading tracking-wide border-2 border-brand-navy shadow-[5px_5px_0_#0A1128] hover:shadow-[8px_8px_0_#0A1128] hover:-translate-x-1 hover:-translate-y-1 transition-all" data-testid="service-area-call">
              <MapPin size={18} /> Confirm Your Area
            </a>
          </div>

          <div className="md:col-span-7">
            <div className="bg-white border-2 border-brand-navy p-6 shadow-[8px_8px_0_#D00017]">
              <div className="text-[11px] uppercase tracking-[0.25em] text-brand-red font-bold mb-4">
                Towns we service daily
              </div>
              <div className="flex flex-wrap gap-2" data-testid="service-area-towns">
                {TOWNS.map((t) => (
                  <span key={t} className="text-sm px-3 py-1.5 bg-brand-navy/5 border border-brand-navy/20 text-brand-navy hover:bg-brand-red hover:text-white hover:border-brand-red transition-colors cursor-default">
                    {t}
                  </span>
                ))}
                <span className="text-sm px-3 py-1.5 text-brand-red font-semibold">+ more</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
